import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { useToast } from 'vue-toastification'

import Network from '@/Network'
import ConfirmDeleteAction from '@/components/designSystem/modals/confirm.delete.action.vue'
import ImportScheduleConfigModal from '@/components/ManageScale/Schedule/modals/ImportScheduleConfigModal.vue'
import { useErrorToast } from '@/composables/useErrorToast'
import type { QualificationRuleGroup } from '@/types/qualification-policy.types'

import { clonePolicy, isPolicyEmpty } from './policyModel'

type PendingCopy = {
  rules: QualificationRuleGroup
  sourcePolicyId: number
  sourceCompanyId: number | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyRequirementsModal',
  props: {
    modalActive: { type: Boolean },
    hasCurrentRequirements: { type: Boolean }
  },
  emits: ["close", "copy"],
  setup(__props: any, { emit }) {

const props = __props;




const toast = useToast()
const { notifyError } = useErrorToast()
const isLoading = ref(false)
const confirming = ref(false)
const pending = ref<PendingCopy | null>(null)

/**
 * Copia localmente (GET da política vigente da origem, A3.5): o gestor revisa antes de salvar.
 * A cópia é independente (D42) — clone profundo, nunca a árvore da origem.
 */
async function onSelect(scheduleId: number, companyId: number | null) {
  if (isLoading.value) return
  isLoading.value = true
  try {
    const { current } = await Network.qualificationEligibility.getSchedulePolicy(scheduleId)
    if (!current || isPolicyEmpty(current.rules)) {
      toast.info('A escala escolhida não tem qualificação exigida para copiar.')
      return
    }
    const copy: PendingCopy = {
      rules: clonePolicy(current.rules),
      sourcePolicyId: current.policyId,
      sourceCompanyId: companyId
    }
    if (props.hasCurrentRequirements) {
      pending.value = copy
      confirming.value = true
      return
    }
    emit('copy', copy.rules, copy.sourcePolicyId, copy.sourceCompanyId)
  } catch (error) {
    notifyError(error, 'Não foi possível copiar os requisitos da escala escolhida')
  } finally {
    isLoading.value = false
  }
}

function confirmReplace() {
  const copy = pending.value
  if (copy) emit('copy', copy.rules, copy.sourcePolicyId, copy.sourceCompanyId)
  pending.value = null
  confirming.value = false
}

/** Volta para a escolha da escala (o seletor reabre do zero). */
function cancelReplace() {
  pending.value = null
  confirming.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ImportScheduleConfigModal, {
      "modal-active": _ctx.modalActive && !confirming.value,
      "is-importing": isLoading.value,
      "confirm-text": "Copiar requisitos",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
      onSelect: onSelect
    }, null, 8, ["modal-active", "is-importing"]),
    _createVNode(ConfirmDeleteAction, {
      show: confirming.value,
      title: "Substituir os requisitos atuais?",
      description: "A cópia é independente: mudar a escala de origem depois não altera esta escala. Os requisitos que você já montou aqui serão substituídos.",
      "text-button": "Substituir requisitos",
      onCloseModal: cancelReplace,
      onHandleConfirm: confirmReplace
    }, null, 8, ["show"])
  ], 64))
}
}

})